import React from 'react'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Link from 'components/_new/typography/Link/Link'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './GiftManual.scss'


const CartOrderItemGiftManual = ({ isGiftSet }) => {
  const discountLink  = isGiftSet ? links.giftSet : links.newProducts
  const discountTitle = isGiftSet ? messages.freeGiftSet : messages.freeProduct

  return (
    <Box mt="16">
      <Link
        className={s.giftManual}
        color="brand"
        withUnderline={false}
        toOLD={discountLink}
      >
        <Text message={discountTitle} size="14-24" align="center" />
      </Link>
    </Box>
  )
}


export default CartOrderItemGiftManual
